module.exports = {
    CTM_invoice: 'CTM請求書',
    accept: '承認',
    add_another_flight: 'フライトを追加',
    add_another_hotel: 'ホテルを追加',
    add_another_service: 'その他のサービスを追加',
    add_flight: 'フライトを追加',
    add_flight_request: 'フライトリクエストを追加',
    add_hotel: 'ホテルを追加',
    add_hotel_request: 'ホテルリクエストを追加',
    add_new_clock: '新しい時計を追加',
    add_other_service: 'その他のサービスを追加',
    add_other_service_request: 'その他サービスリクエストを追加',
    admin_service_fee: '管理サービス料（CTM手数料）',
    advanced_online_trip_proposal_search: '高度なオンライン出張提案検索',
    advanced_search: '詳細検索',
    advanced_trip_request_search: '高度な出張リクエスト検索',
    agency_contact_person: '代理店担当者',
    agency_record_locator: '代理店予約番号',
    airlines: '航空会社',
    airport: '空港',
    all: 'すべて',
    all_detail: 'すべての詳細',
    all_rules: 'すべての規則',
    all_status: 'すべてのステータス',
    already_exist_fmt: '{0} はすでに存在します',
    amenities: 'アメニティ',
    amenities_not_found: 'アメニティが見つかりません',
    ancillary: '付帯サービス',
    any: '任意',
    any_time: 'いつでも',
    approval_declined: '承認却下',
    approval_history: '承認履歴',
    approval_workflow: '承認ワークフロー',
    approve: '承認',
    approve_form_not_found_tip: '承認フォームが見つかりません。トラベルコンサルタントにお問い合わせください',
    approve_request: '承認リクエスト',
    approve_tip: 'この出張リクエストを承認してよろしいですか？',
    approved: '承認済み',
    approver_not_found: '承認者が見つかりません',
    arrival: '到着',
    arrival_Date: '到着日',
    arrival_city: '到着都市',
    at_least_6_characters_in_length: '6文字以上で入力してください',
    at_risk: 'リスクあり',
    attachment: '添付ファイル',
    attachment_size_max_limit_colon: '添付ファイルの最大サイズ：',
    back: '戻る',
    back_to_home_page: 'ホームページに戻る',
    batch_donwnload_zip: '複数ファイルをダウンロードしZIPにまとめる',
    booking_not_found: '予約が見つかりません',
    booking_now: '今すぐ予約',
    booking_num: '予約番号',
    booking_reference: '予約参照番号',
    browser_not_support_webgl: 'Mapbox GL は WebGL サポートが必要です。対応ブラウザを使用し、WebGL が有効になっているか確認してください。',
    budget: '予算',
    business: 'ビジネス',
    cabin: 'キャビン',
    cabin_class: 'キャビンクラス',
    cancel: 'キャンセル',
    cancel_flight_request_tip: 'このフライトリクエストをキャンセルしてよろしいですか？',
    cancel_hotel_request_tip: 'このホテルリクエストをキャンセルしてよろしいですか？',
    cancel_other_service_request_tip: 'このその他サービスリクエストをキャンセルしてよろしいですか？',
    cancel_request: 'リクエストをキャンセル',
    cancel_request_tip: 'この出張リクエストはキャンセルされます。続行しますか？',
    cancel_selection: '選択をキャンセル',
    cancelled: 'キャンセル済み',
    carbon_emission: '二酸化炭素排出量',
    carry_on_bag: '機内持込手荷物',
    carry_on_bag_fmt: '{0}{1} 機内持込手荷物',
    category: 'カテゴリ',
    change_approver: '承認者を変更',
    change_level_approver_fmt: 'レベル{step}の承認者を変更',
    change_password: 'パスワードを変更',
    check_in: 'チェックイン',
    check_in_date: 'チェックイン日',
    check_out: 'チェックアウト',
    check_out_date: 'チェックアウト日',
    check_session_err_tip: 'アカウントからログアウトしました。ブラウザウィンドウをすべて閉じることを推奨します。',
    checked_bag: '受託手荷物',
    checked_bag_fmt: '{0}{1} 受託手荷物',
    chinese_simplified: '簡体字中国語',
    chinese_traditional: '繁体字中国語',
    choose_timezone: 'タイムゾーンを選択',
    city: '都市',
    clear: 'クリア',
    click_drag_upload: 'クリックまたはドラッグしてファイルを追加',
    click_for_detail: '詳細を見る',
    client_company_name: 'クライアント会社名',
    client_information: 'クライアント情報',
    close: '閉じる',
    close_filters: 'フィルタを閉じる',
    code: 'コード',
    comment: 'コメント',
    company: '会社',
    companyName: '会社名',
    company_not_null: '会社を選択してください',
    confirm: '確認',
    confirm_request: 'リクエストを確定',
    confirm_request_tip: 'この出張リクエストを確定してよろしいですか？',
    confirm_trip_detail: '出張詳細を確認',
    confirm_your_new_password: '新しいパスワードを確認',
    contact_person: '担当者',
    contact_phone_num: '担当者電話番号',
    contact_us: 'お問い合わせ',
    continue: '続行',
    copy_link_success: 'リンクをコピーしました',
    corporate_deal: '法人契約',
    country: '国／地域',
    country_code_or_name: '国／地域コードまたは名称',
    create_new: '新規',
    created: '作成済み',
    credit_card_payment: 'クレジットカード決済',
    current_price: '現在の価格',
    daparture_date: '出発日',
    dark: 'ダークモード',
    dashboard: 'ダッシュボード',
    date: '日付',
    date_to_month_end: '月末までの日付',
    day: '{count, plural,=0 {0日}one {1日}other {{count}日}}',
    deactivate: '無効化',
    deadline: '締切',
    deadline_alert: '予約リマインダー',
    decline: '却下',
    delayed: '遅延',
    delete: '削除',
    depart: '出発',
    departing: '出発中',
    departure: '出発',
    departure_city: '出発都市',
    departure_date: '出発日',
    departure_date_from: '出発日（開始）',
    departure_date_to: '出発日（終了）',
    departure_time: '出発時間',
    description: '説明',
    destination: '目的地',
    detail: '詳細',
    details: '詳細情報',
    diff_user_tip_fmt: '最近アカウントを {0} に切り替えました。「更新」をクリックしてください。',
    direct: '直行',
    discount: '割引',
    documents: '書類',
    download: 'ダウンロード',
    download_app: 'アプリをダウンロード',
    download_app_already_login_now: 'アプリはすでにダウンロードされています。今すぐログインしてください。',
    download_ctm_mobile_app: 'CTMモバイルアプリをダウンロード',
    download_link: 'ダウンロードリンク',
    download_pdf: 'ダウンロード',
    duration_fmt: '{hours}時間{minutes}分',
    economy: 'エコノミー',
    edit: '編集',
    edit_flight_request: 'フライトリクエストを編集',
    edit_hotel_request: 'ホテルリクエストを編集',
    edit_note_to_approver: '承認者へのメモを編集',
    edit_other_service_request: 'その他サービスリクエストを編集',
    email: 'メール',
    email__bcc: 'Bcc',
    email__cc: 'Cc',
    email__from: '送信者',
    email__to: '宛先',
    email_dialog_history: 'メール履歴',
    email_dialog_history_not_found: 'メール履歴が見つかりません',
    emissions: '排出量',
    emissions_tip: '選択した座席クラスの1名あたりの排出量を計算しています。',
    en_route: '移動中',
    enable: '有効化',
    end: '終了',
    end_date: '終了日',
    english: '英語',
    enter_a_new_password: '{email} の新しいパスワードを入力してください',
    enter_an_airport: '空港を入力',
    enter_city_airport_name: '都市／空港名を入力',
    error_occurred: 'エラーが発生しました',
    estimate_total: '合計見積り',
    extreme: '非常に高い',
    fare: '運賃',
    fare_class: '運賃クラス',
    fare_forecaster: '運賃予測',
    fare_forecaster_form_prompt: '検索条件を入力して最適な航空券価格を表示してください。',
    fare_forecaster_widget_tip: '希望の時間帯で最適な旅行日を探す',
    fare_not_found: '運賃が見つかりません',
    fare_not_found_tip: '現在予測に必要なデータが不足しています。',
    fare_rules: '運賃規則',
    filter: 'フィルター',
    finalize: '確定',
    first_class: 'ファーストクラス',
    flight: 'フライト',
    flight__from: '出発地',
    flight__to: '目的地',
    flight_budget: 'フライト予算',
    flight_index_fmt: 'フライト {index}',
    flight_ordinal_fmt: '{ordinal}{suffix} フライト',
    flow_type: 'フロータイプ',
    found: '見つかりました',
    free_cancellation_fmt: '{0} まで無料キャンセル可能',
    general_search: '一般検索',
    georisk_map: '地政学リスクマップ',
    hello: 'こんにちは',
    high: '高い',
    higher: 'より高い',
    highest_fare: '最高運賃',
    hotel: 'ホテル',
    hotel_budget: 'ホテル予算',
    hotel_name: 'ホテル名',
    invalid_attachment: '無効な添付ファイル',
    invalid_attachment_type: '無効な添付ファイル形式',
    invalid_email_format: '無効なメールアドレス',
    invalid_message: '無効なメッセージ',
    invalid_parameter: '無効なパラメータ',
    invalid_traveller: '無効な旅行者',
    invoice: '請求書',
    invoice_amount: '請求金額',
    invoices: '請求書一覧',
    voucher: '精算証憑',
    voucher_amount: '精算証憑金額',
    vouchers: '精算証憑',
    itineraries: '旅程一覧',
    itinerary: '旅程',
    itinerary_detail_of_fmt: '{0} の旅程詳細',
    itinerary_information: '旅程情報',
    japanese: '日本語',
    just_loading_your_search_results: '検索結果を読み込み中です',
    keyword: 'キーワード',
    landed: '到着',
    language: '言語',
    later: '後で',
    level_fmt: 'レベル {step}',
    light: 'ライトモード',
    light_dark_mode: 'ライト／ダークモード',
    links: 'CTMインターポータルリンク',
    load_more: 'さらに読み込む',
    loading: '読み込み中...',
    location: '場所',
    login_ctm_lightning_mobile_app: 'このQRコードをスキャンしてCTM Lightningモバイルアプリにログインしてください',
    login_for_mobile: 'Lightningモバイルログイン',
    login_lightning_failed_prompt: 'SSOによるLightningログインに失敗しました。無効なユーザーです',
    login_now: '今すぐログイン',
    logout: 'ログアウト',
    low: '低い',
    lower: 'より低い',
    lowest_fare: '最低運賃',
    lowest_fare_carrier: '最低運賃キャリア',
    lowest_fare_tax: '最低運賃の税金',
    lowest_price: '最安値',
    loyalty_program: '会員プログラム',
    make_booking: '予約を確定',
    make_booking_tip: 'この出張リクエストを予約確定してよろしいですか？',
    manage_your_travel_invoices: '旅行請求書を管理',
    manage_your_travel_vouchers: '旅行精算証憑を管理',
    meal_preference: '食事の希望',
    medium: '中程度',
    message_dialog: 'メッセージダイアログ',
    message_size_max_limit_colon: 'メッセージサイズの最大制限：',
    mobile_phone_login: '携帯電話でログイン',
    moderate: '中程度',
    month_to_date: '今月累計',
    multi_city: '複数都市',
    multi_city_not_support_prompt: '複数都市は未対応です。片道または往復をお試しください',
    my_apps: 'アプリ',
    name: '名前',
    new: '新規',
    new_trip_request: '新規出張リクエスト',
    news: '更新',
    news_feed: 'ニュース',
    nights_count: '宿泊数',
    no_booking_be_alert: '予約リマインダーなし',
    no_booking_for_approval: '承認待ちの予約なし',
    no_booking_for_upcoming: '今後の出張予約なし',
    no_check_in_baggage: '受託手荷物なし',
    no_data: 'データなし',
    no_documents_found: '書類が見つかりません',
    no_limit: '制限なし',
    no_links_found: 'リンクが見つかりません',
    no_need_approval: '承認不要',
    no_news_found: '更新が見つかりません',
    no_online_trip_proposal: 'オンライン出張提案が見つかりません',
    no_risk_news: 'リスク関連ニュースなし',
    no_select_option_tip: 'フライトまたはホテルが未選択です',
    no_trip_request: '出張リクエストが見つかりません',
    non_refundable: '払い戻し不可',
    not_authorized_login_tip: 'このURLへのアクセス権がありません。アクセス前に {0} にログインしてください。',
    not_authorized_tip: 'このURLへのアクセス権がありません',
    not_departed: '出発なし',
    not_included: '含まれていません',
    not_lowest_price_tip: 'この区間は最安値ではありません',
    note_to_approver: '承認者へのメモ',
    off: 'オフ',
    ok: 'OK',
    on: 'オン',
    on_time: '定刻',
    one_way: '片道',
    online_check_in: 'オンラインチェックイン',
    online_trip_proposal: 'オンライン出張提案',
    online_trip_proposal_detail: 'オンライン出張提案詳細',
    online_trip_proposal_search: 'オンライン出張提案検索',
    oops_something_went_wrong: 'エラーが発生しました',
    open_booking_tool: '予約ツールを開く',
    operated_by: '運航会社',
    operated_by_fmt: '{0} により運航',
    operated_on: '運航日',
    operation_history: '操作履歴',
    option: 'オプション',
    option_fmt: 'オプション {0}',
    option_selection_fmt: '{0} オプション選択',
    optional: '任意',
    optional_approve_reason: '任意の承認理由',
    or: 'または',
    order_no: '注文番号',
    original_budget_colon: '当初予算：',
    original_total_colon: '当初合計：',
    other_service: 'その他サービス',
    otp_stop: 'ストップ',
    otp_stopover: '経由地',
    overviews: '概要',
    page_no_right: '403 - このページを表示する権限がありません',
    page_not_found: '404 - ページが見つかりません',
    page_not_found_prompt: '申し訳ありませんが、お探しのページは存在しません。',
    password_policy: 'パスワードポリシー',
    pending: '保留',
    pending_for_approval: '承認待ち',
    per_adult: '大人1人あたり',
    phone: '電話',
    please_confirm_trip_plan_option_first: 'まず出張プランのオプションを確認してください',
    please_enter: '入力してください',
    please_enter_correct_fmt: '正しい{0}を入力してください',
    please_enter_different_city: '別の都市を入力してください',
    please_enter_fmt: '{0} を入力してください',
    please_enter_reject_reason: '却下理由を入力してください',
    please_enter_this_field: 'この項目を入力してください',
    please_enter_trip_name: '出張名を入力してください',
    please_enter_your_email_address: 'メールアドレスを入力してください。パスワード再設定用のメールを送信します。',
    please_fill_in_your_other_requirements: 'その他の要件を入力してください',
    please_select: '選択してください',
    please_select_approver: '承認者を選択してください',
    please_select_fmt: '{0} を選択してください',
    please_select_level_approver_fmt: 'レベル{step}の承認者を選択してください',
    please_select_one_flight_option: 'フライトオプションを1つ選択してください',
    please_select_one_hotel_option: 'ホテルオプションを1つ選択してください',
    pnr_fee: 'PNR手数料',
    premium_economy: 'プレミアムエコノミー',
    preview_email_dialog_history: 'メール履歴をプレビュー',
    previous: '前へ',
    price_currency_tip_fmt: '特に記載がない限り、価格はすべて {currency} 表示です',
    processing_your_booking_now: '予約を処理中です…',
    profile: 'プロフィール',
    proposal_created_tip: '予約が正常に作成されました',
    proposal_ref: '提案番号',
    proposal_submit_tip: '予約を提出して手続きを進めてください',
    read_less: '閉じる',
    read_more: 'もっと見る',
    record_not_found: '記録が見つかりません',
    reference_number: '参照番号',
    refresh: '更新',
    rejected: '却下済み',
    related_booking_info_not_found: '関連する予約情報が見つかりません',
    related_login_not_found: '関連するログインが見つかりません',
    remark: '備考',
    remark_colon: '備考：',
    request_date_from: 'リクエスト日（開始）',
    request_date_to: 'リクエスト日（終了）',
    request_reference: 'リクエスト参照',
    requested: 'リクエスト済み',
    resend_email: 'メールを再送',
    resend_email_success: 'メールを再送しました',
    resend_email_tip: '承認依頼メールを再送してよろしいですか？',
    reset_mfa: 'MFAをリセット',
    reset_mfa_msg: '多要素認証(MFA)はリセットされます。サインアウト後、再登録が必要です。',
    reset_your_password: 'パスワードをリセット',
    retry: '再試行',
    return: '往復',
    return1: '往復',
    return_date: '帰国日',
    return_date_from: '復路出発日',
    return_date_to: '復路帰着日',
    returning: '復路',
    risk_alert_fmt: '{count,plural,=0{リスクサマリーなし}one{1件のリスクサマリー}other{#件のリスクサマリー}}',
    risk_hub: 'リスクハブ',
    risk_level: 'リスクレベル',
    risk_level_up: 'リスクレベル',
    risk_news: 'リスクニュース',
    room: '部屋',
    room_name: '部屋名',
    round_trip: '往復',
    rules: '規則',
    same_city_prompt: '出発都市と到着都市は同じにできません',
    save: '保存',
    scan_qr_code_to_download_app: 'QRコードをスキャンしてアプリをダウンロード',
    scroll: 'スクロール',
    search: '検索',
    search_for_a_document: '書類を検索',
    search_for_a_link: 'リンクを検索',
    search_for_a_news: '更新を検索',
    search_result_colon: '検索結果',
    search_timeout_prompt: '検索がタイムアウトしました。更新してください',
    search_trip: '名前、フライト、ホテル名、場所で検索',
    seat_preference: '座席の希望',
    segment_departure: '出発',
    select: '選択',
    select_approver: '承認者を選択',
    select_approver_success_tip: '承認者の選択に成功しました。予約を確定しますか？',
    select_approver_tip: 'まず承認者を選択し、承認フローを作成してください',
    select_booking_tool: '予約ツールを選択',
    select_date: '日付を選択',
    select_language: '言語',
    select_option_tip_fmt: '以下から{0}オプションを1つ選択してください',
    select_region: 'アカウントを切り替える',
    select_screen_theme: '画面テーマを選択',
    selected: '選択済み',
    selected_fmt: '選択済み {0}',
    selected_room: '選択済みの部屋',
    send_email: 'メール送信',
    service_fee: 'サービス料',
    share: '共有',
    show_all: 'すべて表示',
    show_detail: '詳細を表示',
    show_less: '簡易表示',
    signout: 'サインアウト',
    single_bulk_upload: '単体または一括アップロード対応',
    sme_deal: '中小企業向け契約',
    special_request: '特別リクエスト',
    special_request_remark: '特別リクエスト（備考）',
    start: '開始',
    start_date: '開始日',
    status: 'ステータス',
    stop: 'ストップ',
    stopover: '経由',
    subject: '件名',
    submit: '提出',
    submit_to_approver: '承認者に提出',
    submit_to_approver_tip: 'この出張リクエストを承認者に提出してよろしいですか？',
    submit_to_consultant: 'コンサルタントに提出',
    submit_to_tc_tip: 'この出張リクエストをコンサルタントに提出してよろしいですか？',
    support_attachment_type_colon: '対応添付ファイル形式：',
    surcharge: '追加料金',
    system_information: 'システム情報',
    tax: '税金',
    taxes_tip_with_parenthesis: '（税金・サービス料込み）',
    the_document_was_not_downloaded: 'ドキュメントがダウンロードされませんでしたか？',
    this_flight: 'このフライト',
    ticket_fare_per_person: '1人あたりの航空運賃',
    time_prefer: '時間の希望',
    time_preference: '時間の希望',
    timeout_tip: 'セッションがタイムアウトしました。再度ログインしてください',
    to: '宛先',
    tools: 'ツール',
    total: '合計',
    total_amount: '合計金額',
    total_budget: '合計',
    tp_data_error_tip: 'この出張提案データは不完全です。トラベルコンサルタントにお問い合わせください。',
    transactio_date: '取引日',
    transaction_date_range: '取引期間',
    transaction_fee: '手配手数料（CTMチャージ）',
    transfer: '乗継',
    transfer_in: '乗換',
    transit_time: '乗継時間',
    travel_date_range: '旅行日程範囲',
    travel_time: '旅行時間',
    travel_time1_fmt: '旅行時間: {hours}時間{minutes}分',
    travel_time_fmt: '旅行時間: {hours}時間{minutes}分',
    travelerName: '旅行者名',
    traveler_tracker: '旅行者追跡システム',
    traveller: '旅行者',
    traveller_email: '旅行者メール',
    traveller_information: '旅行者情報',
    traveller_names: '旅行者名一覧',
    traveller_not_found: '旅行者が見つかりません',
    traveller_udid_not_found: '旅行者UDIDが見つかりません',
    trip_between: '{endDate,select,noLimit{{startDate,select,noLimit{全旅程を表示}other{{previous}以降の旅程を表示}}}other{{startDate,select,noLimit{{upcoming}以前の旅程を表示}other{{previous}と{upcoming}の間の旅程を表示}}}}',
    trip_count_fmt: '{count,plural,=0{出張なし}one{1件の出張}other{#件の出張}}',
    trip_information: '出張情報',
    trip_name: '出張名',
    trip_overview: '出張概要',
    trip_plan_fmt: '出張計画 {0}',
    trip_request: '出張リクエスト',
    trip_request_detail: '出張リクエスト詳細',
    trip_request_search: '出張リクエスト検索',
    type: 'タイプ',
    typical_for_this_route: 'このルートの標準',
    unknown: '不明',
    upcoming: '今後',
    upcoming_trips: '今後の出張',
    update_search: '検索を更新',
    update_success: '更新成功',
    update_trip_information: '出張情報を更新',
    view_in: '表示方法',
    warning: '警告',
    week: '{count, plural,=0 {0週}one {1週}other {{count}週}}',
    where_from: '出発地はどこですか？',
    where_to: '目的地はどこですか？',
    widgets: 'ウィジェット',
    world_clock: '世界時計',
    write_a_message_here: 'ここにメッセージを入力...',
    you_have_not_select_flight: 'フライトが選択されていません',
    you_have_not_select_hotel: 'ホテルが選択されていません',
    you_have_signed_out: '{0} から正常にサインアウトしました',
    your_new_password: '新しいパスワード',
    your_password_has_been_reset_successfully: 'パスワードは正常にリセットされました',
    background_downloads: '背景ダウンロード',
    background_downloads_tips: '5秒ごとに自動更新されます。各請求書の所要時間は~5秒です。',
    background_downloads_tips_vouchers: '5秒ごとに自動更新されます。各精算証憑の所要時間は~5秒です。',
    requested_at: '初めの',
    total_invoices: '領収証カウント',
    total_vouchers: '精算証憑件数',
    estimated_time_remaining: '残り推定時刻',
    preparing: '準備',
    actions: '動作',
    apply: '申請',
    apply_vouchers: '精算証憑を申請',
    apply_vouchers_success: '精算証憑の申請に成功しました',
    apply_vouchers_failed: '精算証憑の申請に失敗しました',
    please_select_invoice_apply: '少なくとも1件の請求書データを選択してください',
    expire_date: '満了日',
    downloading: 'ダウンロード中',
}